import { render } from "./LandingPage.vue?vue&type=template&id=a6a7e902&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=a6a7e902&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a6a7e902"

export default script